import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "12",
  height: "12",
  viewBox: "0 0 12 12",
  fill: "none"
}
const _hoisted_2 = { "clip-path": "url(#clip0_5155_7611)" }
const _hoisted_3 = ["fill"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("defs", null, [
  /*#__PURE__*/_createElementVNode("clipPath", { id: "clip0_5155_7611" }, [
    /*#__PURE__*/_createElementVNode("rect", {
      width: "12",
      height: "12",
      fill: "white"
    })
  ])
], -1)

import { PropType } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'zoomInIcon',
  props: {
  color: {
    type: String as PropType<string>,
    default: "#B7B7B7",
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _createElementVNode("g", _hoisted_2, [
      _createElementVNode("path", {
        d: "M4.25 11.25C4.25 11.4489 4.32902 11.6397 4.46967 11.7803C4.61032 11.921 4.80109 12 5 12H7C7.19891 12 7.38968 11.921 7.53033 11.7803C7.67098 11.6397 7.75 11.4489 7.75 11.25V7.875C7.75 7.84185 7.76317 7.81005 7.78661 7.78661C7.81005 7.76317 7.84185 7.75 7.875 7.75H11.25C11.4489 7.75 11.6397 7.67098 11.7803 7.53033C11.921 7.38968 12 7.19891 12 7V5C12 4.80109 11.921 4.61032 11.7803 4.46967C11.6397 4.32902 11.4489 4.25 11.25 4.25H7.875C7.84185 4.25 7.81005 4.23683 7.78661 4.21339C7.76317 4.18995 7.75 4.15815 7.75 4.125V0.75C7.75 0.551088 7.67098 0.360322 7.53033 0.21967C7.38968 0.0790176 7.19891 0 7 0L5 0C4.80109 0 4.61032 0.0790176 4.46967 0.21967C4.32902 0.360322 4.25 0.551088 4.25 0.75V4.125C4.25 4.15815 4.23683 4.18995 4.21339 4.21339C4.18995 4.23683 4.15815 4.25 4.125 4.25H0.75C0.551088 4.25 0.360322 4.32902 0.21967 4.46967C0.0790176 4.61032 0 4.80109 0 5L0 7C0 7.19891 0.0790176 7.38968 0.21967 7.53033C0.360322 7.67098 0.551088 7.75 0.75 7.75H4.125C4.15815 7.75 4.18995 7.76317 4.21339 7.78661C4.23683 7.81005 4.25 7.84185 4.25 7.875V11.25Z",
        fill: __props.color
      }, null, 8, _hoisted_3)
    ]),
    _hoisted_4
  ]))
}
}

})